import React, { useMemo, useState } from "react";
import { CalendarMonth } from "@mui/icons-material";
import { IconButton, Popover, TextField } from "@mui/material";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";

const FORMATO_COMPETENCIA = "MM/YYYY";

function paraDayjs(valor) {
  if (!valor) return null;
  const [mes, ano] = valor.split("/");
  return dayjs(`${ano}-${mes}-01`);
}

function formatar(valor) {
  return valor ? valor.format(FORMATO_COMPETENCIA) : "";
}

function formatarResumo(inicio, fim) {
  if (!inicio || !fim) return "";
  return inicio.isSame(fim, "month")
    ? formatar(inicio)
    : `${formatar(inicio)} a ${formatar(fim)}`;
}

export default function SeletorCompetencia({
  competenciaInicial,
  competenciaFinal,
  setCompetenciaInicial,
  setCompetenciaFinal,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const inicio = useMemo(() => paraDayjs(competenciaInicial), [competenciaInicial]);
  const fim = useMemo(() => paraDayjs(competenciaFinal), [competenciaFinal]);
  const resumo = inicio && fim
    ? formatarResumo(inicio, fim)
    : inicio
      ? `${formatar(inicio)} a ...`
      : "Selecione a competência";

  const selecionar = valor => {
    if (!valor?.isValid()) return;

    const competencia = formatar(valor);
    if (!inicio || fim || valor.isBefore(inicio, "month")) {
      setCompetenciaInicial(competencia);
      setCompetenciaFinal("");
      return;
    }

    setCompetenciaFinal(competencia);
    setAnchorEl(null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <TextField
        label="Competência"
        value={resumo}
        variant="outlined"
        size="small"
        fullWidth
        onClick={event => setAnchorEl(event.currentTarget)}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton size="small" aria-label="Selecionar competência">
              <CalendarMonth fontSize="small" />
            </IconButton>
          ),
        }}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <DateCalendar
          value={fim ? fim.startOf("month") : inicio?.startOf("month") || null}
          views={["year", "month"]}
          openTo="month"
          onChange={selecionar}
        />
      </Popover>
    </LocalizationProvider>
  );
}
